import { environment } from 'src/environments/environment';

export const PLATFORM_BASE_PATH = environment.baseURL;
